import React from 'react';
import img01 from '../../assets/images/uspb.webp';
import img02 from '../../assets/images/uspc.webp';
import { siteCopy } from '../../content/siteCopy';

const highlightIcons = [img01, img01, img02, img01];

const Whychooseus = () => {
  const { highlights } = siteCopy.aboutUs;

  return (
    <>
      <section
        className="why_choose row_am white_text"
        data-aos="fade-in"
        data-aos-duration={1500}
      >
        <div className="why_choose_inner">
          <div className="container">
            <div
              className="section_title"
              data-aos="fade-up"
              data-aos-duration={1500}
            >
              <span className="title_badge">{highlights.badge}</span>
              <h2>{highlights.title}</h2>
              <p>{highlights.intro}</p>
            </div>
            <div className="company_statistics">
              <ul
                className="app_statstic"
                data-aos="fade-in"
                data-aos-duration={1500}
              >
                {highlights.items.map((item, index) => (
                  <li key={item.caption} data-aos="fade-up" data-aos-duration={1500}>
                    <div className="text">
                      <div className="usp_img">
                        <img src={highlightIcons[index]} alt="" />
                      </div>
                      <p>
                        <span>{item.label}</span>
                        {item.suffix ? <span>{item.suffix}</span> : null}
                      </p>
                      <p>{item.caption}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Whychooseus;
